// hooks/useManagerOptions.ts
import { useEffect, useState } from "react";
import { IListagemUsuario, userService } from "../../../shared/services/api/user/userService";
import { useProfile } from "../../../context/ProfileContext";

type Option = {
	id: string;
	label: string;
};

export function useManagerOptions(searchTerm: string) {
	const { isSuperAdmin, permissionLevel } = useProfile();
	const [managerOptions, setManagerOptions] = useState<Option[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// Proteção de perfil
		if (!isSuperAdmin && permissionLevel !== 2) return;

		const cleaned = typeof searchTerm === "string" ? searchTerm.trim() : "";
		if (!cleaned) return;

		const timeout = setTimeout(() => {
			setLoading(true);

			userService.getAdminManagers(cleaned).then((result) => {
				if (!(result instanceof Error)) {
					const options = (result.data ?? []).map((user: IListagemUsuario) => ({
						id: user.id,
						label: user.name,
					}));
					setManagerOptions(options);
				}
				setLoading(false);
			});
		}, 400);

		return () => clearTimeout(timeout);
	}, [searchTerm, isSuperAdmin, permissionLevel]);

	return { managerOptions, loading };
}
